export const TipoDeProcessoEnum = {
    LEGALIZACAO: 1,
    ALTERACAO: 2,
    ENCERRAMENTO: 3,
}